import React, { useEffect } from "react";
import { CustomButton } from "../../components/CustomButton";
import { MdError } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ContactUs from "../../components/ContactUs";
import GoogleTag from "../../components/GoogleTag";

const CANCEL_TITLE = "Betalningen misslyckades";
const BACK_BUTTON_TEXT = "Tillbaka till startsidan";

const PaymentCancelPage: React.FC = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/"); // Redirect to the home page
  };

  // Remove the isn from localStorage when the page loads
  useEffect(() => {
    localStorage.removeItem("isn");
  }, []);

  return (
    <main className="flex-grow h-full flex items-center justify-center">
      <GoogleTag />
      <div className="flex flex-col justify-center items-center w-full">
        <div className="max-w-[600px] flex flex-col gap-8 w-full h-full justify-center items-center p-9 bg-primary-card rounded-lg">
          <MdError className="w-20 h-20 text-red-500" />
          <h1 className="text-white text-4xl font-nunito">{CANCEL_TITLE}</h1>
          <h5 className="text-white text-xl font-nunito leading-snug text-center">
            Betalningen kunde inte genomföras. Försök igen.
          </h5>
          <CustomButton
            customStyles="h-[56px] w-full sm:max-w-[330px]"
            onClick={handleBackClick}
          >
            {BACK_BUTTON_TEXT}
          </CustomButton>
          <ContactUs />
        </div>
      </div>
    </main>
  );
};

export default PaymentCancelPage;
